import RequestAbstract from "../abstract";

export default class PartnersReferrals extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/partners/referrals";
    }
}
